import React, { Component } from "react";
import styles from "./flyout.css";

import Flyout from "./flyout";

class FlyoutContainer extends Component {
	constructor() {
		super();

		this.state = {
			showFlyout: false
		};

		this.showFlyout = this.showFlyout.bind(this);
		this.hideFlyout = this.hideFlyout.bind(this);
	}

	showFlyout(event) {
		event.preventDefault();

		this.setState({ showFlyout: true }, () => {
			document.addEventListener("click", this.hideFlyout);
		});
	}

	hideFlyout(event) {
		// Clicks outside of flyout content close flyout
		if (
			this.flyoutContainerContent &&
			!this.flyoutContainerContent.contains(event.target)
		) {
			this.setState({ showFlyout: false }, () => {
				document.removeEventListener("click", this.hideFlyout);
			});
		}
	}

	render() {
		return (
			<div className={styles.flyoutContainer}>
				<div onClick={this.showFlyout}>{this.props.children[0]}</div>

				{this.state.showFlyout ? (
					<div
						className={styles.flyoutContainerContent}
						ref={element => {
							this.flyoutContainerContent = element;
						}}
					>
						<Flyout>{this.props.children[1]}</Flyout>
					</div>
				) : null}
			</div>
		);
	}
}

export default FlyoutContainer;



// WEBPACK FOOTER //
// ./src/components/ui/flyout/flyoutContainer.js